import { Component, EventEmitter, forwardRef, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { HierarchyService } from '@app/features/hierarchy/services/hierarchy.service';
import { CustomOverlayDescriptor } from '@app/shared/services/overlay/custom-overlay.service';
import { EntitySelectionModel } from '@components/data/data-table-new/entitySelectionModel';
import {
  InputStringtableComponent,
  StringTableStrategy
} from '@components/form-controls/inputs/input-stringtable/input-stringtable.component';
import { Subject } from 'rxjs';
import { GetHierarchyDto, NodeDto } from '../../models/hierarchy.model';

@Component({
  selector: 'vfs-hierarchy-string-tree',
  templateUrl: './hierarchy-string-tree.component.html',
  styleUrls: ['./hierarchy-string-tree.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => HierarchyStringTreeComponent)
    }
  ]
})
export class HierarchyStringTreeComponent implements OnInit, ControlValueAccessor {
  @Input() isFilter = false;
  @Input() filterData: any;
  @Input() closeSidenav = true;
  @Input() overlaySubject$: Subject<boolean>;
  @Input() hierarchy: GetHierarchyDto;
  @Input() ngModel: string[] = [];
  @Input() selection: EntitySelectionModel<any>;
  @Input() initialSelection: NodeDto[] = [];
  @Input() required: boolean;
  @Input() disabled: boolean;
  @Input() disabledButton = false;
  @Input() customOverlayDescriptor: CustomOverlayDescriptor;
  @Input() formControl: FormControl;
  @Output() ngModelChange = new EventEmitter<any>();
  @Output() changeValue = new EventEmitter<NodeDto[]>();
  @Output() clear = new EventEmitter();
  @ViewChild(InputStringtableComponent) inputStringtable: InputStringtableComponent;
  // ControlValueAccessor
  value: any;

  @Input() public nodeStrategy: StringTableStrategy<NodeDto> = (selection: EntitySelectionModel<NodeDto>) => {
    this.changeValue.emit(selection.selected);
    return selection.selected.filter(node => node != null).map(node => this.hierarchyService.getNodeDescriptor(node));
  };

  constructor(protected hierarchyService: HierarchyService) {}

  ngOnInit() {
    if (
      this.initialSelection &&
      this.initialSelection.length > 0 &&
      this.initialSelection.every(selection => Object.keys(selection).length > 0)
    ) {
      this.selection.select(...this.initialSelection);
      this.ngModel = this.selection.selected.map(selected => selected.id) as string[];
      this.ngModelChange.emit(this.ngModel);
    }
  }

  change(event) {
    this.ngModelChange.emit(event);
  }

  clearEvt() {
    this.clear.emit();
    this.ngModel = [];
  }

  isValid(): boolean {
    return this.inputStringtable && this.inputStringtable.ngModelIsValid();
  }

  // ControlValueAccessor functions
  onChange = (rating: number) => {};
  onTouched = () => {};

  writeValue(obj: any): void {
    this.value = obj;
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
